'use client';

import { ProductListSearchParams } from '@/blocks/ProductList/types';
import { pseudoI18n } from '@/i18n/pseudoI18n';
import { ChangeEvent } from 'react';
import { useRouter } from 'next/navigation';

export default function ListSort( props: { sortParams: ProductListSearchParams['s'] }) {
  const { sortParams } = props;

  const { t } = pseudoI18n();
  const router = useRouter();

  const onChangeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
    const currentUrl = new URL(window.location.href);
    const newSortValue = event.target.value;

    currentUrl.searchParams.set('s', newSortValue);
    router.push(currentUrl.toString());
  };

  return (
    <div className="ml-auto">
      {t('Sort by')}:
      <select
        defaultValue={sortParams}
        onChange={onChangeHandler}
        className="cursor-pointer ml-1.5 px-2.5 py-1.5 font-semibold text-sm rounded-md border border-neutral-400 gap-1"
      >
        <option value="newest">{t('Newest')}</option>
        <option value="oldest">{t('Oldest')}</option>
      </select>
    </div>
  );
}
